import script from "./PgmBudgetStarter.vue?vue&type=script&setup=true&lang=ts"
export * from "./PgmBudgetStarter.vue?vue&type=script&setup=true&lang=ts"

import "./PgmBudgetStarter.vue?vue&type=style&index=0&id=24a0a365&lang=scss&scoped=true"
import "./PgmBudgetStarter.vue?vue&type=style&index=1&id=24a0a365&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24a0a365"]])

export default __exports__